import Toggle from "../../../components/Toggle.jsx";
import LoadingComponent from "../../../components/LoadingComponent.jsx";
import { Trans, useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { ProjectApi } from "../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../api/utilities/useAuthorityConfiguration.js";
import toast from "react-hot-toast";
import { useErrorTranslation } from "../../../api/utilities/translateErrorMessage.js";
import Button from "../../../components/Button.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import YesNo from "../../../components/YesNo.jsx";
import ActionButton from "../../../components/ActionButton.jsx";
import { useRenderNumber } from "../../../api/utilities/useValueRenderers.js";

export default function ProjectDomain({ project, domainWithStats, onReload, onToggleChange, isSaving, isDisabled, isEnabled }) {
    const { t } = useTranslation();
    const { et } = useErrorTranslation();
    const authorityConfiguration = useAuthorityConfiguration();
    const renderNumber = useRenderNumber();
    const renderCountLabel = (label, count) => {
        const formattedCount = String(renderNumber(count));

        if (typeof label !== 'string' || !label.startsWith(formattedCount)) {
            return label;
        }

        return <><strong className={'font-semibold text-slate-900 dark:text-slate-50'}>{formattedCount}</strong>{label.slice(formattedCount.length)}</>;
    };

    const [deleteYesNoOpen, setDeleteYesNoOpen] = useState(false);
    const [deleteYesNoConfirmed, setDeleteYesNoConfirmed] = useState(false);

    useEffect(() => {
        if (deleteYesNoConfirmed !== true) {
            return;
        }

        new ProjectApi(authorityConfiguration)
            .deleteProjectDomain({
                projectId: project.id,
                deleteProjectDomainInput: {
                    hostName: domainWithStats.projectDomain.hostName,
                },
            })
            .then(() => {
                onReload();
            })
            .catch((e) => et(e).then((message) => { if (message) toast.error(message); }));
    }, [deleteYesNoConfirmed]);

    return [
        <YesNo
            key={'pd-yesno'}
            question={
                <Trans
                    i18nKey="project.really-delete-domain-x"
                    defaults="Opravdu chcete smazat doménu <strong>{{domain}}</strong>?"
                    values={{domain: domainWithStats.projectDomain.hostName}}
                    components={{strong: <strong className="font-semibold text-gray-900 dark:text-gray-50"/>}}
                />
            }
            visible={deleteYesNoOpen || deleteYesNoConfirmed}
            setVisible={setDeleteYesNoOpen}
            onYes={() => setDeleteYesNoConfirmed(true)}
            loading={deleteYesNoConfirmed}
            yesLabel={t('project.delete-domain-confirm', {defaultValue: 'Smazat'})}
            noLabel={t('project.cancel-domain-delete', {defaultValue: 'Zrušit'})}
            yesVariant="danger"
            noVariant="outline-black"
            actionsGapClassName="gap-2"
            actionButtonClassName="w-auto min-w-28 whitespace-nowrap !rounded-lg !px-4 !py-2"
        />,
        <div
            key={'pd-row'}
            className={
                'comp__integrationListItem ' +
                'flex gap-2 justify-items-start items-center p-2' + ' ' +
                'px-4 mb-3 app-surface rounded-xl bg-white border-1' + ' ' +
                'dark:border-0 dark:bg-slate-800'
            }
        >
            <div className={'min-w-0 flex-1'}>
                <div className={'flex items-center'}>
                    <img src={domainWithStats.projectDomain.faviconUrl} alt={'favicon'} className={'w-4 h-4'} />
                    <strong className={'ml-2 truncate text-slate-900 dark:text-slate-50'}>{domainWithStats.projectDomain.hostName}</strong>
                </div>
                <div className={'mt-1 flex flex-wrap gap-x-4 text-sm text-slate-500 dark:text-slate-400'}>
                    <span>{renderCountLabel(t('project.domain-campaign-amount', {count: domainWithStats.projectDomainStats.campaignCount, formattedCount: renderNumber(domainWithStats.projectDomainStats.campaignCount)}), domainWithStats.projectDomainStats.campaignCount)}</span>
                    <span>{renderCountLabel(t('project.domain-ad-amount', {count: domainWithStats.projectDomainStats.adCount, formattedCount: renderNumber(domainWithStats.projectDomainStats.adCount)}), domainWithStats.projectDomainStats.adCount)}</span>
                    <span>{renderCountLabel(t('project.domain-order-amount', {count: domainWithStats.projectDomainStats.orderCount, formattedCount: renderNumber(domainWithStats.projectDomainStats.orderCount)}), domainWithStats.projectDomainStats.orderCount)}</span>
                </div>
            </div>
            <LoadingComponent
                className={'ml-auto'}
                loadedClassName={'flex gap-2 items-center justify-center'}
                loading={isSaving}
            >
                <Toggle
                    enabled={isEnabled}
                    setEnabled={(newValue) => !isDisabled && onToggleChange(domainWithStats.projectDomain.hostName, newValue)}
                    disabled={isDisabled || isSaving}
                />
                {!domainWithStats.projectDomain.isBuiltin && (
                    <ActionButton
                        icon={'trash'}
                        className={'align-center'}
                        disabled={isSaving}
                        onClick={() => {
                            if (!domainWithStats.projectDomain.isBuiltin && !isSaving) {
                                setDeleteYesNoOpen(true);
                            }
                        }}
                    >
                    </ActionButton>
                )}
            </LoadingComponent>
        </div>,
    ];
}
